export const enableOpacity: number = 0.56;
export const disableOpacity: number = 0.3;
